import SiteMessage, { SiteMessageButton } from "./SiteMessage";

function MarketplaceNotFound() {
  return (
    <SiteMessage
      title="Marketplace is Currently Unavailable"
      subtitle="Contact the marketplace administrator or browse the Builtfirst Marketplace instead."
    >
      <SiteMessageButton
        href="https://marketplace.builtfirst.com"
        variant="contained"
      >
        Visit Builtfirst&apos;s Marketplace
      </SiteMessageButton>
    </SiteMessage>
  );
}

export default MarketplaceNotFound;
